

































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import {
    getHttpAxiosAsObservable,
    hasElements,
    Lazy,
    LegendMap,
    Method,
    VisualizationApply
} from '../../../core/utils';
import { combineLatest, of, Subject } from 'rxjs';
import { existCountElement } from '../../../core/operators';
import Actions from '../Actions.vue';
import TableFilter from './TableFilter.vue';
import VisualizationsPanel from './VisualizationsPanel.vue';
import {
    DataVisualization,
    Filter,
    HistoricalVisualizationResponse,
    Marker,
    Visualization
} from '../../../core/models';
import { catchError, exhaustMap, map, startWith, tap, withLatestFrom } from 'rxjs/operators';
import { MessageInfo } from '../../../core/components';
import { TrackingService } from '../../../core/api';
import Axios from 'axios';
import { NotificationStoreHelper, RootStoreHelper, VehicleStoreHelper } from '../../../core/mixins';
import { FilterDialogStore, titleConfirmationWindow, titleErrorWindow, titleWindow } from './state';
import { cssError, cssNormal, cssWarning, getNumberByPaintingType, PaintingType } from '../../utils';
import * as chroma from 'chroma-js';

@Component<FilterDialog>({
    components: { MessageInfo, TableFilter, Actions, VisualizationsPanel },
    domStreams: ['triggerDeleteSub$'],
    subscriptions() {
        const headClass$ = this.store.headClass$;
        const selected$ = this.store.selected$;
        const visualizationSelected$ = this.store.visualizationSelected$;
        const visualizationsSelected$ = selected$.pipe(
            map((selecteds: Filter[]) => (selecteds.length === 1 ? selecteds[0].visualizations : []))
        );
        return {
            title$: this.store.title$,
            headClass$,
            loading$: this.store.selectLoading(),
            selected$,
            visualizationSelected$,
            noFilterSelected$: selected$.pipe(
                existCountElement(0),
                startWith(true),
                tap(() => this.handleCancelDelete())
            ),
            existOneFilerSelected$: selected$.pipe(
                existCountElement(1),
                startWith(false)
            ),
            existMultipleFilerSelected$: selected$.pipe(
                existCountElement((selecteds: Filter[]) => selecteds.length > 1),
                startWith(false)
            ),
            disableFilterWithVisualization$: combineLatest([
                selected$.pipe(startWith([])),
                visualizationSelected$.pipe(startWith(null))
            ]).pipe(
                map(([filters, _]) => {
                    if (filters.length > 1) {
                        return true;
                    }
                    const visualizationSelected = this.store.getVisualizationSelected();
                    const filterActive = this.getFilterActive(filters, visualizationSelected);
                    return filterActive ? true : false;
                })
            ),
            visualizationsFromFilterSelected$: visualizationsSelected$,
            existVisualizationsFromFilterSelected$: visualizationsSelected$.pipe(
                map((visualizations: Visualization[]) => !!(visualizations && visualizations.length))
            ),
            filterActive$: visualizationSelected$.pipe(
                map((visualizationSelected: Visualization | null) =>
                    visualizationSelected !== null ? this.getFilterActive(this.filters, visualizationSelected) : null
                ),
                startWith(null)
            ),
            normal$: headClass$.pipe(
                map<string, boolean>(headClass => headClass === cssNormal),
                startWith(true)
            ),
            warning$: headClass$.pipe(
                map<string, boolean>(headClass => headClass === cssWarning),
                startWith(false)
            ),
            error$: headClass$.pipe(
                map<string, boolean>(headClass => headClass === cssError),
                startWith(false)
            ),
            delete$: this.triggerDeleteSub$.pipe(
                tap(() => {
                    this.store.updateLoading(true);
                }),
                map(eventTrigger => eventTrigger['data']),
                withLatestFrom(selected$),
                map(([visualizationSelected, selecteds]) => {
                    const cancelDeleteRequest = Axios.CancelToken.source();
                    return {
                        ids: selecteds.map(filter => filter.id),
                        token: cancelDeleteRequest,
                        visualizationSelected: visualizationSelected
                    };
                }),
                exhaustMap(({ ids, token, visualizationSelected }) =>
                    getHttpAxiosAsObservable(TrackingService.deleteFilterById(ids, token), token).pipe(
                        tap((response: any) => {
                            if (response['status'] === 200 || response['status'] === 204) {
                                this.$_successDeleteFilter('Eliminado correctamente');
                                this.applyNormalState();
                                this.removeFilters(ids);
                                this.store.updateSelected([]);
                            }
                            this.store.updateLoading(false);
                            const filterActive = this.getFilterActive(this.filters, visualizationSelected);
                            if (filterActive) {
                                for (let i = 0; i < ids.length; i++) {
                                    if (ids[i] === filterActive.id) {
                                        this.handleUnApplyVisualization(visualizationSelected);
                                        break;
                                    }
                                }
                            }
                        }),
                        catchError(error => {
                            this.applyErrorState();
                            this.store.updateLoading(false);
                            return of([]);
                        })
                    )
                )
            )
        };
    }
})
export default class FilterDialog extends Mixins(NotificationStoreHelper, VehicleStoreHelper, RootStoreHelper) {
    @Prop({ default: false }) openFilterDialog: boolean;
    @Prop({ default: false }) cancelFilerSelected: boolean;
    @Prop() closeFilterDialog: Lazy<void>;
    @Prop() showAddFilterDialog: Method<{ filter: Filter | null; isFilterSelected: boolean }, void>;
    @Prop() filters: Filter[];
    @Prop() removeFilters: Method<string[], void>;
    @Prop() setApplyFilterState: Method<boolean, void>;
    @Prop() applyVisualization: Method<VisualizationApply | null, Promise<HistoricalVisualizationResponse>>;
    @Prop() updateMarkersHistoricalFromVisualizationApply: Method<Marker[], void>;
    store: FilterDialogStore = new FilterDialogStore();
    title$: string;
    headClass$: string;
    loading$: boolean = false;
    selected$: Filter[];
    visualizationSelected$: Visualization | null;

    existOneFilerSelected$: boolean;
    existMultipleFilerSelected$: boolean;
    noFilterSelected$: boolean;

    visualizationsFromFilterSelected$: Visualization[];
    existVisualizationsFromFilterSelected$: boolean;
    filterActive$: Filter;

    normal$: boolean;
    warning$: boolean;
    error$: boolean;

    triggerDeleteSub$: Subject<any>;
    filterActive: Filter | null = null;

    messageError = 'No se puedo eliminar el filtro...';
    messageWarning = '¿Esta seguro de eliminar el filtro?';

    applyNormalState(): void {
        this.store.updateHeadClass(cssNormal);
        this.store.updateTile(titleWindow);
    }

    applyWarningState(): void {
        this.store.updateHeadClass(cssWarning);
        this.store.updateTile(titleConfirmationWindow);
    }

    applyErrorState(): void {
        this.store.updateHeadClass(cssError);
        this.store.updateTile(titleErrorWindow);
    }

    handleAddFilter(): void {
        this.closeFilterDialog();
        this.showAddFilterDialog({ filter: null, isFilterSelected: false });
    }

    handleSelectOneFilter(selectedFilter: Filter, selected: boolean): void {
        if (selected) {
            this.store.updateSelected([...this.store.getSelected(), selectedFilter]);
        } else {
            this.store.updateSelected(this.store.getSelected().filter(select => select.id !== selectedFilter.id));
        }
    }

    handleApplyVisualization(visualization: Visualization | null): void {
        const filterActive = this.getFilterActive(this.filters, visualization);
        if (filterActive && visualization) {
            this.store.updateLoading(true);
            this.applyVisualization({
                filterId: filterActive.id,
                visualizationId: visualization.id
            })
                .then((result: HistoricalVisualizationResponse | null) => {
                    this.store.updateLoading(false);
                    if (result && hasElements(result.tracking)) {
                        this.store.updateVisualizationSelected(visualization);
                        this.updateMarkersHistoricalFromVisualizationApply(this.buildMarkers(result, visualization));
                        this.filterActive = filterActive;
                    } else {
                        this.store.updateVisualizationSelected(null);
                        this.applyVisualization(null);
                        this.$_showEmptyApplyVisualization('La visualización seleccionada no contiene información');
                        this.filterActive = null;
                    }
                })
                .catch(error => {
                    this.store.updateVisualizationSelected(null);
                    this.store.updateLoading(false);
                    this.$_errorApplyVisualization(error.message);
                    this.applyVisualization(null);
                });
        }
    }

    buildMarkers(response: HistoricalVisualizationResponse, visualization: Visualization): Marker[] {
        this.$_setLegend(null);
        let markers: Marker[] = [];
        const colors = this.getTones(visualization);
        const intervals = this.getIntervals(visualization);
        for (let i = 0; i < response.tracking.length; i++) {
            const datas: DataVisualization[] = response.tracking[i].data;
            const id: number = response.tracking[i].vehicle_id;
            for (let j = 0; j < datas.length; j++) {
                const data: any = datas[j];
                markers.push({
                    lat: data.lat,
                    lng: data.lng,
                    icon: {
                        rotation: data.rotation,
                        path: ''
                    },
                    info: this.$_getVehiclesMap[id],
                    infoState: {
                        speed: 0,
                        color: this.calculeColor(
                            datas[j].value as number,
                            intervals,
                            colors,
                            visualization.min,
                            visualization.max
                        ),
                        work_order_dest: null,
                        work_order_mount: null,
                        work_order_number: null,
                        work_order_unload_date: null,
                        work_order_load_state: 0,
                        vehicle_type: 0,
                        vehicle_state: data.vehicle_state,
                        timestamp: data.timestamp,
                        state: `${data.vehicle_state}`,
                        metters: visualization.working_width
                    }
                });
            }
        }
        this.$_setLegend(
            this.getLegend(
                colors,
                intervals,
                visualization.max,
                visualization.variable.unit ? visualization.variable.unit : ''
            )
        );

        return markers;
    }

    round(num: number): number {
        return Math.round(num * 100) / 100;
    }

    getLegend(colors: string[], intervals: number[], max: number, unit: string): LegendMap {
        let result: LegendMap = {};
        for (let i = 0; i < intervals.length; i++) {
            if (i === intervals.length - 1) {
                result = { 
                    ...result, 
                    [`${this.round(intervals[i])} - ` + ` ${this.round(max)} ${unit} `]: {
                        color: colors[i],
                        styles: {}
                    }
                };
            } else {
                result = {
                    ...result,
                    [`${this.round(intervals[i])} - ` + ` ${this.round(intervals[i + 1])} ${unit}`]: {
                        color: colors[i],
                        styles: {}
                    }
                };
            }
        }
        return result;
    }

    getTones(visualization: Visualization): string[] {
        let sourceColor;
        let targetColor;
        if (visualization.painting_type === getNumberByPaintingType(PaintingType.RED_GREEN)) {
            sourceColor = 'red';
            targetColor = 'green';
        } else {
            sourceColor = 'green';
            targetColor = 'red';
        }
        return chroma.scale([sourceColor, '#ffff00', targetColor]).colors(visualization.tone_quantity);
    }

    getIntervals(visualization: Visualization): number[] {
        const interval: number[] = [];
        const rest = visualization.max - visualization.min;
        const partition = rest / visualization.tone_quantity;
        let count = visualization.min;
        for (let i = 0; i < visualization.tone_quantity; i++) {
            interval.push(count);
            count = count + partition;
        }
        return interval;
    }

    calculeColor(value: number, interval: number[], colors: string[], min: number, max: number): string {
        let color: string = 'black';
        if (value < min || value > max) {
            return color;
        }
        for (let i = 0; i < interval.length; i++) {
            if (i === interval.length - 1 && (value <= interval[i] || value >= max)) {
                color = colors[i];
                break;
            } else if (value <= interval[i]) {
                color = colors[i];
                break;
            }
        }
        return color;
    }

    handleUnApplyVisualization(visualization: Visualization | null): void {
        this.applyVisualization(null).then(() => {
            this.store.updateVisualizationSelected(null);
            this.$_setLegend(null);
            this.filterActive = null;
        });
    }

    getFilterActive(filters: Filter[], visualization: Visualization | null): Filter | null {
        let filter: Filter | null = null;
        if (visualization !== null) {
            for (let i = 0; i < filters.length; i++) {
                for (let j = 0; j < filters[i].visualizations.length; j++) {
                    if (filters[i].visualizations[j].id === visualization.id) {
                        filter = filters[i];
                        break;
                    }
                    if (filter) {
                        break;
                    }
                }
            }
        }
        return filter;
    }

    @Watch('openFilterDialog')
    observerOpenFilterDialog(value) {
        if (value) {
            this.store.updateSelected([]);
            this.reload();
        }
    }

    reload(): void {
        if (this.cancelFilerSelected) {
            this.handleUnApplyVisualization(null);
            this.setApplyFilterState(false);
        }
    }

    handleCancelDelete() {
        if (!this.normal$) {
            this.applyNormalState();
        }
    }

    handleEdit(): void {
        this.closeFilterDialog();
        const filter = this.selected$[0];
        const isFilterSelected = !!(this.filterActive && filter.id === this.filterActive.id);
        this.showAddFilterDialog({ filter, isFilterSelected });
    }
}
